import { ReplyComponentType } from "./CommentTypes";
import {
    ReplyContainerGrid,
    ReplyImage,
    ReplyTextContainerGrid,
    ReplyUserNameTypography,
} from "./Reply.styles";
import { getUserName } from "../../Shared/UserHelpers";
import React from "react";
import { getCommentText } from "./Comment";
import { TextMarkup } from "../../Shared/Components/TextMarkup/TextMarkup";
import { TEXT_ELLIPSIS } from "../../Shared/styles";
import { truncateAfterManualLinebreak } from "../../Shared/TruncateAfterManualLinebreak";
import { LinkoutReply } from "./LinkoutReply";

export function Reply({
    id,
    images = [],
    user,
    text,
    onClick,
    linkoutUrl,
    isDeleted,
    isSuspended,
}: ReplyComponentType) {
    return (
        <ReplyContainerGrid onClick={() => onClick?.(id)}>
            {images?.length > 0 && <ReplyImage src={images[0].url} />}
            <ReplyTextContainerGrid>
                <ReplyUserNameTypography>
                    {getUserName(user?.screenName)}
                </ReplyUserNameTypography>
                <TextMarkup
                    textToMarkup={
                        getCommentText({ isSuspended, isDeleted }, () => {
                            return truncateAfterManualLinebreak(text);
                        }) ?? ""
                    }
                    sx={{
                        margin: "0",
                        fontSize: "12px",
                        color: "var(--community-color-secondary-text)",
                        ...TEXT_ELLIPSIS,
                        "& ul, ol": {
                            whiteSpace: "nowrap",
                            display: "inline-list-item",
                        },
                        "& > *": {
                            display: "inline",
                        },
                    }}
                />
                {linkoutUrl && <LinkoutReply linkoutUrl={linkoutUrl} />}
            </ReplyTextContainerGrid>
        </ReplyContainerGrid>
    );
}
